<!-- MSAL Authentication Loading Screen -->
<!-- Shown during initial MSAL auth check and app config load -->
<div *ngIf="isLoading" class="auth-loading-overlay">
	<div class="auth-loading-container">
		<sdk-loading [isLoading]="true"></sdk-loading>
		<p class="auth-loading-text">Initializing application...</p>
	</div>
</div>

<!-- Authentication Error State -->
<!-- Shown if MSAL authentication fails -->
<error *ngIf="error !== '' && !isLoading" [message]="error"></error>

<!-- No Access State -->
<!-- Shown when user is authenticated but not authorized to access the app -->
<access *ngIf="layoutCssClass === 'noaccess' && !isLoading"></access>

<!-- Main Application Content -->
<!-- Only shown after successful authentication and authorization -->
<ng-container *ngIf="isLoggedIn && !isLoading">
	<!-- Header/Navigation (only shown after MSAL auth completes) -->
	<header [title]="title" (reloadPage)="reloadPage()"></header>

	<!-- Main Content Area with Router Outlet -->
	<!-- Routes are protected by MsalGuard -->
	<content [ngClass]="{ 'no-footer': !showFooter }" [class]="layoutCssClass">
		<router-outlet></router-outlet>
	</content>

	<!-- Footer -->
	<footer *ngIf="showFooter"></footer>
</ng-container>

<!-- Modal/Dialog Container -->
<!-- For dynamic modal content -->
<div *ngIf="modal" class="modal-window">
	<div class="locked"></div>
	<ng-container [ngComponentOutlet]="modal.type" [ndcDynamicInputs]="modal.inputs" [ndcDynamicOutputs]="modal.outputs"></ng-container>
</div>

<!-- Alert/Confirmation Dialog -->
<!-- For user confirmations and alerts -->
<div *ngIf="showAlert" class="modal-window">
	<div class="locked"></div>
	<alert
		[title]="alertTitle"
		[message]="alertMessage"
		[continueText]="alertContinueText"
		[cancelText]="alertCancelText"
		(continueEvent)="alertContinue()"
		(cancelEvent)="alertCancel()"></alert>
</div>
